import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const ContactUs = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = { name, email, phone, subject, message };
        console.log('Submitted Data:', data);
        // Handle email sending or API submission here
    };
    return (
        <>
            <div className="ContactUs-mainsection">
                <div className='container-fluid'>
                    <div className='aboutus-bgsection'>
                        <div className='container'>
                            <h2 className='aboutus-header'>Contact Us</h2>
                            <div>
                                <h3 className='pages-head'> <NavLink to={'/'} className="about-s">HOME</NavLink> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' />Contact Us</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="contactus-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="contactus-boxsec">
                                    <img className="contactus-boxsecim" src="../assets/images/contactus/img-contact1.jpg" alt="contact us" />
                                    <div className="contactus-boxsec2">
                                        <div className="contactus-boxsec2main">
                                            <img className="contactus-boxsec2mainim" src="../assets/images/contactus/image001.png" alt="Send Us Mail" />
                                        </div>
                                        <h3 className="contactus-boxsec2head">Send Us Mail</h3>
                                        <p className="contactus-boxsec2txt">hr@4sightek.com</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="contactus-boxsec">
                                    <img className="contactus-boxsecim" src="../assets/images/contactus/img-contact2.jpg" alt="contact us" />
                                    <div className="contactus-boxsec2">
                                        <div className="contactus-boxsec2main">
                                            <img className="contactus-boxsec2mainim" src="../assets/images/contactus/image002.png" alt="Send Us Mail" />
                                        </div>
                                        <h3 className="contactus-boxsec2head">Call Us Anytime</h3>
                                        <p className="contactus-boxsec2txt">+1 945-419-8003</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="contactus-boxsec">
                                    <img className="contactus-boxsecim" src="../assets/images/contactus/img-contact3.jpg" alt="contact us" />
                                    <div className="contactus-boxsec2">
                                        <div className="contactus-boxsec2main">
                                            <img className="contactus-boxsec2mainim" src="../assets/images/contactus/image003.png" alt="Send Us Mail" />
                                        </div>
                                        <h3 className="contactus-boxsec2head">Visit Our Office</h3>
                                        <p className="contactus-boxsec2txt">4099 McEwen Rd. Suite 504 Dallas,<br /> TX 75244.</p>
                                        {/* <p className="contactus-boxsec2txt">United States of America.</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contactus-mapandformsection">
                    <div className="container">
                        {/* <img className="mapsection" src="../assets/images/contactus/map.png" alt="map" /> */}
                        {/* <div className="mapsection">
                            <div className=""><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1920&height=600&hl=en&q=10713 N MacArthur Blvd, Irving, TX – 75063&t=h&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google map embed html</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:600px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:600px;}.gmap_iframe {height:600px!important;}" }} /></div>
                        </div> */}

                        <div class="mapsection">
                            <div class="embed-responsive embed-responsive-16by9 map-wrapper">
                                <iframe class="embed-map-frame" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=600&height=400&hl=en&q=7300%20State%20Hwy%20121%2C%20Suite%20300%2C%20McKinney%2C%20Texas-%2075070&t=&z=14&ie=UTF8&iwloc=B&output=embed"></iframe>
                            </div>
                        </div>




                        <div className="formsection">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="formleftsection">
                                        <div className='form-settings'>
                                            <img className='settingsicon' src='../assets/images/icons/settingsicon.png' alt='settings' />
                                            <h3 className='formthead'>SEND US A MAIL</h3>
                                        </div>
                                        <h3 className="formheadtext">Let’s Discuss a
                                            Project Together</h3>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="formrightsection">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input
                                                    type="text"
                                                    placeholder="Name*"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    required
                                                    className="forninp"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="email"
                                                    placeholder="Email Address*"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                    className="forninp"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input
                                                    type="text"
                                                    placeholder="Phone No*"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    required
                                                    className="forninp"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="text"
                                                    placeholder="Subject*"
                                                    value={subject}
                                                    onChange={(e) => setSubject(e.target.value)}
                                                    required
                                                    className="forninp"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <textarea
                                                    placeholder="Text Here"
                                                    value={message}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                    rows={5}
                                                    className="forninp forninp2"
                                                />
                                            </div>
                                        </div>
                                        <button className="formbtnsub">Send Mail</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUs;